import Axios from 'axios'
import moment from 'moment'
const p = (path = '') => `${window.$ApiHost}/orders/${path ? path + '/' : path}`
const state = {
  params: {
    page: 1,
    limit: localStorage.getItem('ordersPerPage') || 10,
    status: '',
  },
  total_pages: 0,
  total_objects: 0,
  items: [],
  itemsMore: [{ email: 'All', id: -1 }],
  hasItemsMore: true,
  isLoading: true,
  isLoadingMore: true,
}
const mutations = {
  // eslint-disable-next-line camelcase
  SET_LIST_ORDERS(state, { total_pages, total_objects, limit, page, results, status }) {
    // eslint-disable-next-line camelcase
    state.total_objects = total_objects
    // eslint-disable-next-line camelcase
    state.total_pages = total_pages
    state.items = results.map(e => ({
      ...e,
      created_at: moment(e.created_at).format('L'),
      updated_at: moment(e.updated_at).format('L'),
      approved_at: moment(e.approved_at).format('L'),
    }))
    state.params.limit = limit
    localStorage.setItem('ordersPerPage', limit)
    state.params.page = page
    state.params.status = status
  },
  // eslint-disable-next-line camelcase
  SET_LIST_ORDERS_MORE(state, { results, total_objects }) {
    results.forEach(newElement => {
      const oldElementIndex = state.itemsMore.findIndex(oldElement => oldElement.id === newElement.id)
      if (oldElementIndex !== -1) {
        state.itemsMore[oldElementIndex] = newElement
      } else {
        state.itemsMore.push(newElement)
      }
    })
    // eslint-disable-next-line camelcase
    state.hasItemsMore = total_objects >= state.itemsMore.length
  },
  IS_LOADING_ORDERS(state, bool) {
    state.isLoading = bool
  },
  IS_LOADING_ORDERS_MORE(state, bool) {
    state.isLoading = bool
  },
}
const actions = {
  async getItems({ commit }, params = { ...state.params }) {
    commit('IS_LOADING_ORDERS', true)
    let response
    try {
      response = await Axios.get(p(), { params })
      commit('SET_LIST_ORDERS', { ...response.data, ...params })
    } catch (error) {
      response = error.response
    } finally {
      commit('IS_LOADING_ORDERS', false)
    }
    return response
  },
  async getOrder({ commit }, id) {
    let response
    try {
      response = await Axios.get(p(id))
      commit('SET_LIST_ORDERS_MORE', { results: [response.data] })
    } catch (error) {
      response = error.response
    }
    return response
  },
  async getScvOrders(_, ordersIds = []) {
    let response
    try {
      response = await Axios.post(p('export'), { orders_id: ordersIds })

      const blob = new Blob([response.data])
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `orders-${new Date()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    } catch (error) {
      response = error?.response
    }
    return response
  },
}
export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
